import { render } from "./RosaryPrayers.vue?vue&type=template&id=198b73a0"
import script from "./RosaryPrayers.vue?vue&type=script&lang=js"
export * from "./RosaryPrayers.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__